var e=3e4,r=6e4;export{r as GEOLOCATION_MAXIMUM_AGE,e as GEOLOCATION_TIMEOUT};
//# sourceMappingURL=geolocation.constants.js.map
